import { utils } from './-global.min.js'

const {
  formatPrice,
  one,
  all
} = utils

class HHProductVariant extends HTMLElement {
  constructor() {
    super()

    this.quantity = 1
    this.suffix = this.dataset.suffix
    this.product_id = this.dataset.section
    this.parent_product_id = this.dataset.parentProduct
    this.isBundle = this.dataset.isBundle === 'true'
    this.$swatches = all('.js-swatch__button', this)
    this.$options = all('.js-option__button', this)
    this.$optionGroup = one('.js-option__group', this)
    this.$optionGroups = all('.js-option__group', this)
    this.$quantityGroup = one('.js-quantity__group', this)
    this.$quantities = all('.js-quantity__button', this)
    this.currentSwatch = this.$optionGroup.dataset.currentSwatch

    this.setCurrentOptions = this.setCurrentOptions.bind(this)
    this.clickSwatch = this.clickSwatch.bind(this)
    this.updateOptions = this.updateOptions.bind(this)
    this.updateMedia = this.updateMedia.bind(this)
    this.updateMasterId = this.updateMasterId.bind(this)
    this.updatePrice = this.updatePrice.bind(this)
    this.updateURL = this.updateURL.bind(this)
    this.updateVariantInput = this.updateVariantInput.bind(this)
    this.updateActiveSwatchButton = this.updateActiveSwatchButton.bind(this)
    this.updateOptionState = this.updateOptionState.bind(this)

    this.clickOption = this.clickOption.bind(this)
    this.updateActiveOptionButton = this.updateActiveOptionButton.bind(this)

    this.updateAvailability = this.updateAvailability.bind(this)
    this._toggleAvailabilityOptions = this._toggleAvailabilityOptions.bind(this)
    this._toggleAvailabilitySwatches = this._toggleAvailabilitySwatches.bind(this)
    this._toggleAvailabilityQuantities = this._toggleAvailabilityQuantities.bind(this)

    this.clickQuantity = this.clickQuantity.bind(this)
    this.updateQuantityInput = this.updateQuantityInput.bind(this)

    this.applyToBundle = this.applyToBundle.bind(this)

    this.$discount = one('.js-product-panel').dataset.discount;

  }

  connectedCallback() {
    this.attachListeners()

    this.setCurrentOptions()
    this.updateMasterId()
  }

  disconnectedCallback() {
    this.removeListeners()
  }

  setCurrentOptions() {
    this.currentOptions = []
    if (this.currentSwatch) {
      this.currentOptions.push(this.currentSwatch)
    }
    let opt = null
    this.$optionGroups.forEach((group, index) => {
      opt = one('.option__button--active', group)
      this.currentOptions[this.currentSwatch ? index + 1 : index] = opt?.dataset.value
    })
  }

  clickSwatch(item) {
    const swatch = item.dataset.value
    if (swatch == this.currentSwatch) return
    this.currentSwatch = swatch

    this.updateOptions(true, item)
    this.updateOptionState(true, item)
    this.updateActiveSwatchButton();
  }

  clickOption(item) {
    this.updateOptions(false, item)
    this.updateOptionState(false, item)
    this.updateActiveOptionButton(item);
  }

  updateOptionState(isSwatch, item) {
    this.updateMasterId()
    if(isSwatch)
      this.updateMedia()
    this.updatePrice()
    this.updateURL()
    this.updateVariantInput()

    // Refresh available status of all options
    this.updateAvailability(isSwatch, item)

    // function for bundle products
    this.applyToBundle()
    this.updateVariantLink()
  }
  updateVariantLink() {
    var productId = $('.product-hero').data('product-id');
    var current_var_id  = $('form[data-product-id="'+productId+'"]').find('input[name="id"]').attr('value');
    if(current_var_id != '' && current_var_id != undefined){      
      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + current_var_id;
    window.history.replaceState({path: newurl}, '', newurl);
    }
  }
  applyToBundle() {
    const bundleItem = this.closest('.bundle-item-wrapper')
    if (!bundleItem) return

    const bundleAction = one('.bundle-item__action', bundleItem)
    if (this.currentVariant.available) {
      bundleItem.setAttribute('data-variant', JSON.stringify(this.currentVariant))
      bundleAction.removeAttribute('disabled')

      document.dispatchEvent(
        new CustomEvent('bundle-price::change')
      )
    } else {
      bundleAction.setAttribute('disabled', '')
    }
  }

  updateAvailability(isSwatch, item) {
    const option_values = []
    if (isSwatch) {
      option_values.push(item.dataset.value)
    } else {
      if (this.currentSwatch) {
        option_values.push(this.currentSwatch)
        this._toggleAvailabilitySwatches(item)
      }
    }

    this._toggleAvailabilityOptions(option_values, item)
    this._toggleAvailabilityQuantities()
  }

  _toggleAvailabilitySwatches(item) {
    const option_values = []
    let variant = null
    this.$swatches.forEach((swatch) => {
      option_values[0] = swatch.dataset.value
      option_values[1] = item.dataset.value
      variant = this.getVariantData().find((va) => {
        return !va.options
          .map((option, i) => {
            return option_values[i] === option
          })
          .includes(false)
      })
      swatch.classList[variant?.available ? 'remove' : 'add']('swatch__button--oos')
    })
  }

  _toggleAvailabilityOptions(options, item) {
    let newIndex = 0,
      groupIndex = 0,
      variant = null

    if (this.$optionGroups.length > 1) {
      newIndex = this.currentSwatch ? 1 : 0
      this.$optionGroups.forEach((group, index) => {
        if (group === item.closest('.js-option__group')) {
          groupIndex = index
          options[newIndex + index] = item.dataset.value
        }
      })
      this.$optionGroups.forEach((group, index) => {
        if (index !== groupIndex) {
          newIndex = this.currentSwatch ? index + 1 : index
          all('.js-option__button', group).forEach((opt) => {
            options[newIndex] = opt.dataset.value
            variant = this.getVariantData().find((va) => {
              return !va.options
                .map((option, i) => {
                  return options[i] === option
                })
                .includes(false)
            })
            opt.classList[variant?.available ? 'remove' : 'add']('option__button--oos')
          })
        }
      })
    } else {
      newIndex = this.currentSwatch ? 1 : 0
      all('.js-option__button', this.$optionGroups[0]).forEach((opt) => {
        options[newIndex] = opt.dataset.value
        variant = this.getVariantData().find((va) => {
          return !va.options
            .map((option, i) => {
              return options[i] === option
            })
            .includes(false)
        })
        opt.classList[variant?.available ? 'remove' : 'add']('option__button--oos')
      })
    }
  }

  _toggleAvailabilityQuantities() {
    if (this.$quantityGroup) {
      all('.js-quantity__button', this.$quantityGroup).forEach((item) => {
        item.classList[this.currentVariant.available ? 'remove' : 'add']('option__button--oos')
      })
    }
  }

  clickQuantity(item) {
    this.quantity = parseInt(item.dataset.btnIndex)
    this.$quantities.forEach((opt) => {
      opt.classList[opt.dataset.btnIndex === item.dataset.btnIndex ? 'add' : 'remove']('option__button--active')
    })
    this.updateQuantityInput()
    this.updatePrice()
  }

  updateActiveSwatchButton() {
    let option_name = ''
    this.$swatches.forEach((item) => {
      if (item.dataset.value === this.currentSwatch) {
        item.classList.add('swatch__button--active');
      } else {
        item.classList.remove('swatch__button--active')
      }
      option_name = item.dataset.type
    })

    const group_label = `${option_name} <mark>${this.currentSwatch}</mark>`
    if(!this.currentVariant.available) {
      one('.js-swatch__group-label', this).innerHTML = `${group_label} <mark class="sold-out">(Sold Out)</mark>`
    } else {
      one('.js-swatch__group-label', this).innerHTML = group_label
    }
// Ensure updateActiveOptionButton is called for the active option
this.$options.forEach((item) => {
  if (item.classList.contains('option__button--active')) {
    this.updateActiveOptionButton(item);
  }
});

  }

  updateActiveOptionButton(option) {
 //   console.log('running active button script');
    var option_name = ''
    let swatchName = option.getAttribute('data-value');
    const option_group = option.closest('.js-option__group')
    all('.js-option__button', option_group).forEach((item) => {
      if (item.dataset.value === option.dataset.value) {
        item.classList.add('option__button--active')
        if ($('.bundle-item-wrapper').length > 0) {
            // we also need to add this class so that we dont accidentally repick queen
            item.classList.add('option-already-selected')
        }
      } else {
        item.classList.remove('option__button--active')
      }
      option_name = item.dataset.type
    })
    var group_label = `${option_name} <mark>${swatchName}</mark>`;
// Define the group class based on the option name
// Define the group class based on the option name
var groupClass = 'option__group--' + option_name;

// Select the label element within the group
var labelElement = one('.' + groupClass + ' .option__group-label', this);

// Check if the label element exists
if (labelElement) {
  // Check if the current variant is available
  if (!this.currentVariant.available) {
    // Update the label to indicate the item is sold out
    labelElement.innerHTML = `${group_label} <mark class="sold-out">(Sold Out)</mark>`;
  } else {
    // Update the label to the default group label
    labelElement.innerHTML = group_label;
  }
} else {
  console.error('Label element not found for group class: ' + groupClass);
}
var option_name = ''
this.$swatches.forEach((item) => {
  if (item.dataset.value === this.currentSwatch) {
    item.classList.add('swatch__button--active');
  } else {
    item.classList.remove('swatch__button--active')
  }
  option_name = item.dataset.type
})

var group_label = `${option_name} <mark>${this.currentSwatch}</mark>`
if(!this.currentVariant.available) {
  one('.js-swatch__group-label', this).innerHTML = `${group_label} <mark class="sold-out">(Sold Out)</mark>`
} else {
  one('.js-swatch__group-label', this).innerHTML = group_label
}
  }

  updateOptions(is_swatch, item) {
    this.currentOptions = []
    if(this.currentSwatch)
      this.currentOptions.push(this.currentSwatch)
    if (is_swatch) {
      let opt = null
      this.$optionGroups.forEach((group, index) => {
        opt = one('.option__button--active', group)
        this.currentOptions[index + 1] = opt?.dataset.value
      })
    } else {
      let opt = null,
        parentGroup = item.closest('.js-option__group')
      this.$optionGroups.forEach((group, index) => {
        if (group !== parentGroup) {
          opt = one('.option__button--active', group)
          this.currentOptions[this.currentSwatch? index + 1: index] = opt?.dataset.value
        } else {
          this.currentOptions[this.currentSwatch? index + 1: index] = item.dataset.value
        }
      })
    }
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.currentOptions[index] === option
        })
        .includes(false)
    })

    const data = {
      product_id: this.product_id,
      available: this.currentVariant.available,
      is_bundle: this.isBundle,
      variant_id: this.currentVariant.id,
      selling_plan_id: this.currentVariant.selling_plan_allocations[0].selling_plan_id
    }

    document.dispatchEvent(
      new CustomEvent('variant-available::change', { bubbles: true, detail: data })
    )
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentSwatch) return
    let options = this.variantData;
    // Assuming this.currentVariant.id is already defined with the ID you're looking for
let matchingOptionId = this.currentVariant.id;

// Using .find() to find the matching option
let matchingOption = options.find(option => option.id === matchingOptionId);
var mySlider = $(this).parent().parent().parent().find('.js-product-media-slider').eq(0);
var myOtherMedia = $(this).parent().parent().parent().find('.other_media').eq(0);
    const data = {
      product_id: this.product_id,
      parent_id: this.parent_product_id,
      variant_id: this.currentVariant.id,
      product_url: this.dataset.url,
      is_bundle: this.isBundle,
      variant_details: matchingOption,
      this_slider: mySlider,
      other_media: myOtherMedia
    }
    document.dispatchEvent(
      new CustomEvent('product-media::change', { bubbles: true, detail: data })
    )
  }

  updatePrice() {
    if (!this.currentVariant || this.isBundle) return

    const price_elem = one(`#price-${this.dataset.section}`)

    if (this.currentVariant.compare_at_price && this.currentVariant.compare_at_price > this.currentVariant.price) {
      if (this.$discount) {
      price_elem.innerHTML = `<del>${formatPrice(this.currentVariant.compare_at_price * this.quantity).replace('.00', '')}</del>` +
        `<ins>${formatPrice((this.currentVariant.price - (this.currentVariant.price * this.$discount)) * this.quantity).replace('.00', '')}</ins>`
      }
      else {
      price_elem.innerHTML = `<del>${formatPrice(this.currentVariant.compare_at_price * this.quantity).replace('.00', '')}</del>` +
        `<ins>${formatPrice(this.currentVariant.price * this.quantity).replace('.00', '')}</ins>`
      }
    } else if(this.$discount) {
      price_elem.innerHTML = `<del>${formatPrice((this.currentVariant.price) * this.quantity).replace('.00', '')}</del>` +
        `<ins>${formatPrice((this.currentVariant.price - (this.currentVariant.price * this.$discount)) * this.quantity).replace('.00', '')}</ins>`
    } else {
      price_elem.innerHTML = formatPrice(this.currentVariant.price * this.quantity).replace('.00', '')
    }

      // Declare global variables to store the totals
var crossout_total_price = 0;
var actual_total_price = 0;

// when the page loads, we must update the pricing based on upsell product and pricing
if ($('.upsell-container-wrapper').length > 0) {
  
  var thisVariant = this.currentVariant;
  var thisObject = this;
  setTimeout(function() {
  $('.upsell-container-wrapper').each(function() {
        // Skip if the upsell-container-wrapper is inside the popup
        if ($(this).closest('.popup').length > 0) {
      //    console.log('Skipping upsell-container-wrapper pricing skip');
          return; // Skip this iteration
        }
        else {
     //    console.log('pricigin is a running');
        }
    if ($(this).index() === 2) {
      var newdiscount = parseFloat(thisObject.$discount)+.1;
      var crossout_price_text = (thisVariant.price /100).toString();
      var actual_price_text = ((thisVariant.price - (thisVariant.price * newdiscount)) /100).toString();
      if ($(this).find('.retain-selection').length === 0) {
      $(this).find('del').text('$'+crossout_price_text);
      $(this).find('ins').text('$'+actual_price_text);
      }
    }
    else {
    var crossout_price_text = $(this).find('.product-panel__price.upsell-pricing del').text().trim();
    var actual_price_text = $(this).find('.product-panel__price.upsell-pricing ins').text().trim();
    }
   // console.log('my cross out price is ' + crossout_price_text);
  //  console.log('my actual price is ' + actual_price_text);
    // Remove any non-numeric characters like '$' and commas, and convert to number
    var crossout_price = parseFloat(crossout_price_text.replace(/[^\d.-]/g, ''));
    var actual_price = parseFloat(actual_price_text.replace(/[^\d.-]/g, ''));

    // Add the prices to the totals
    crossout_total_price += crossout_price;
    actual_total_price += actual_price;

    // Log the individual prices for debugging
  });

  // Format the totals to include a dollar sign and handle decimals
  var formatted_crossout_total = crossout_total_price % 1 === 0 
    ? '$' + crossout_total_price.toFixed(0)  // No decimal if the number is a whole number
    : '$' + crossout_total_price.toFixed(2); // Two decimals if not a whole number

  var formatted_actual_total = actual_total_price % 1 === 0 
    ? '$' + actual_total_price.toFixed(0)  // No decimal if the number is a whole number
    : '$' + actual_total_price.toFixed(2); // Two decimals if not a whole number

  $('.js-product-panel').find('.product-panel__price').eq(0).find('del').text(formatted_crossout_total);
  $('.js-product-panel').find('.product-panel__price').eq(0).find('ins').text(formatted_actual_total);
},50);
}
  }
  updateURL() {
    if (!this.currentVariant || this.suffix || this.isBundle) return

    window.history.replaceState(
      {},
      '',
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    )
  }

  updateVariantInput() {
    if (!this.currentVariant) return

    const productForms = document.querySelectorAll(
      `#product-form-${this.product_id}`
    )
    productForms.forEach((productForm) => {
      const input = one('input[name="id"]', productForm)
      input.value = this.currentVariant.id
    })
  }

  updateQuantityInput() {
    if (!this.currentVariant) return

    const productForms = document.querySelectorAll(
      `#product-form-${this.product_id}`
    )
    productForms.forEach((productForm) => {
      const input = one('input[name="quantity"]', productForm)
      input.value = this.quantity
    })
  }

  attachListeners() {
    this.$swatches.forEach((item) => {
      item.addEventListener('click', (event) => this.clickSwatch(item))
    })

    this.$options.forEach((item) => {
      item.addEventListener('click', (event) => this.clickOption(item))
    })

    this.$quantities.forEach((item) => {
      item.addEventListener('click', (event) => this.clickQuantity(item))
    })
  }

  removeListeners() {
    this.$swatches.forEach((item) => {
      item.removeEventListener('click', (event) => this.clickSwatch(item))
    })

    this.$options.forEach((item) => {
      item.removeEventListener('click', (event) => this.clickOption(item))
    })

    this.$quantities.forEach((item) => {
      item.removeEventListener('click', (event) => this.clickQuantity(item))
    })
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent)
    return this.variantData
  }
}

customElements.define('hh-product-variant', HHProductVariant);
